module.exports = __webpack_public_path__ + "img/Google+.27605e1c.jpg";